import {
  CreateRunReportRequest,
  PublishRunReportRequest,
  RunReportFileUrlsResponse,
  RunReportListResponse,
  RunReportResponse,
  RunReportStateResponse,
  RunReportVersionResponse,
  UpdateRunReportValuesRequest,
} from '@/types/runReportTypes';
import { AvailableReportsResponse } from '@/types/reportBundleTypes';
import { FusaReply } from '@/types/replyTypes';
import { Client } from './client';

export class RunReportFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  /** this org's test reports, for the Reports list */
  list(): Promise<RunReportListResponse> {
    return this.client.read('/api/run-reports');
  }

  /** the reports a report template can make */
  listDefinitions(): Promise<AvailableReportsResponse> {
    return this.client.read('/api/run-reports/definitions');
  }

  readByRunId(runId: string): Promise<RunReportStateResponse> {
    return this.client.read(`/api/run-reports/run/${runId}`);
  }

  create(data: CreateRunReportRequest): Promise<RunReportResponse> {
    return this.client.create('/api/run-reports', data);
  }

  updateValues(id: string, data: UpdateRunReportValuesRequest): Promise<RunReportResponse> {
    return this.client.patch(`/api/run-reports/${id}/values`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/run-reports/${id}`);
  }

  publish(id: string, data: PublishRunReportRequest = {}): Promise<RunReportVersionResponse> {
    return this.client.create(`/api/run-reports/${id}/versions`, data);
  }

  readVersion(id: string, versionId: string): Promise<RunReportVersionResponse> {
    return this.client.read(`/api/run-reports/${id}/versions/${versionId}`);
  }

  fileUrls(id: string, fileIds: string[]): Promise<RunReportFileUrlsResponse> {
    return this.client.create(`/api/run-reports/${id}/file-urls`, { fileIds });
  }
}
